/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-no-comment-textnodes */

import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import {
  BlockCinema,
  Carousel,
  Footer,
  NamedHeader,
  PageIntroKnaifel,
  QuoteCinema,
  SidesKnaifel,
  Spacer,
  SubTitle,
  Text,
  TypographyWrapper,
} from "../../../lib";

export const NBSP = () => <span style={{ opacity: 0 }}>[</span>;

export function QuoteBlock() {
  return <span>«Шурик, а сделай-ка „Письмо Ленина к съезду“».</span>;
}

const Image = styled.img`
  width: 100%;
`;

const QuoteCinemaText = styled(Text)`
  text-transform: lowercase;
`;

const { PUBLIC_URL } = process.env;

const Recognition: React.FC = () => (
  <TypographyWrapper>
    <NamedHeader name="время" />

    <PageIntroKnaifel author="knaifel" name="recognition" />

    <Spacer size={10} />

    <Carousel
      autoHeight
      slides={[
        { url: `${PUBLIC_URL}/assets/images/knaifel/recognition/top.jpg` },
      ]}
    />

    <Spacer half size={10} />

    <SidesKnaifel hideRight="source">
      <BlockCinema>
        <SubTitle>победоносный</SubTitle>
        <>
          Я родился в самом эпицентре, в эту эвакуацию страшную. В тот момент,
          когда судьба цивилизации просто висела на волоске. Представьте себе:
          март 1943 года, никто не знал, что вообще будет. Мои молодые родители
          – студентка и аспирант – были эвакуированы с консерваторией, как и
          очень многие из Ленинграда, в Ташкент. И вот там выяснилось, что я
          могу родиться. Мой дедушка, несмотря на такое невероятное время,
          сказал: «Раз так, значит, так и будет». И когда я родился, меня
          назвали Александр в надежде на грядущую победу. Как бы Победоносный.
          Так гласит семейная легенда. Уже в девятимесячном возрасте мы
          вернулись в Ленинград.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>матушка</SubTitle>
        <>
          Моя матушка – Музочка, дивная. У нее сорок пять выпусков в специальной
          музыкальной школе-десятилетке. Когда в восьмьдесят лет она приходила в
          филармонию на концерт, оркестр весь вставал, потому что все они были
          ее учениками. И в первом оркестре, и во втором оркестре, и вообще где
          бы то ни было.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[A—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/2.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>отец</SubTitle>
        <>
          Отец – Арон Иосифович Кнайфель, замечательный скрипач и ансамблист,
          много играл соло. Он организовал квартет, с которым объездил
          полстраны. Репетировали в [соседней] комнате, и я всегда приходил на
          эти репетиции и слушал, затаив дыхание. Квартет для меня вечно
          звучащий: со сна, сквозь сон, где-то ночью, вечером, при побуждении.
          Он меня сопровождает всю жизнь.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/3.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>враждебный мир</SubTitle>
        <>
          В школе, как и в студенческие годы, совершенно я не понимал, где я и
          что я. Окружающий мир казался чужим и более того – враждебным.
          Чувствовал себя в клетке, и единственная мысль: «За что? В чем я
          провинился?» Неотступное чувство ужаса – ты ничего не знаешь и никогда
          ничего не поймешь. Казалось, все требуемые знания никак не связаны с
          тем, что может быть действительно важным в жизни.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>ростропович</SubTitle>
          <QuoteCinemaText>иосиф райскин, музыковед:</QuoteCinemaText>
          <>
            Закончив консерваторскую школу-десятилетку в 1961 году по классу
            виолончели у Эммануила Фишмана и выдержав труднейший конкурс,
            поступил в Московскую консерваторию, где следующие два года учился у
            Мстислава Ростроповича.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[B—A]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          У Ростроповича оказался я, так сказать, «благодаря» Шостаковичу.
          Истинное знакомство с инструментом началось с его Первого
          виолончельного концерта; вероятно, я был первым, кто после М. Л. его
          исполнил. Всю партию освоил по радиотрансляции премьеры, не видя даже
          нот. Потом была издана партитура, и мы с Геннадием Банщиковым, с
          которым учились в одном классе и который превосходно читал любые
          партитуры, преподнесли весь концерт Мстиславу Леопольдовичу, что
          произвело на него «нешуточное» впечатление.
        </>
        <Spacer half size={4} />
        <SubTitle>в москву</SubTitle>
        <>
          Тогда, вдохновившись, мы решили – поедем поступать в Московскую
          консерваторию. И еще решили – если примут, Гена напишет, а я исполню
          его новый виолончельный концерт. Так и случилось. На прослушивании мы
          заставили москвичей трепетать. Одним из экзаменаторов был Эдисон
          Денисов – в то время еще аспирант. Он слышал о моем «подвиге» с
          концертом Шостаковича и решил на этой почву учинить форменный допрос.
          Задал миллион вопросов, но уж Шостаковича я, кажется, знал едва ли не
          лучше самого Шостаковича. «Не знаю, что ты здесь делаешь!» – хмыкнул
          он (и был прав!). Вскоре мы стали лучшими друзьями.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/4.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>чужой – и среди своих, и среди чужих </SubTitle>
        <>
          Но в Москве мне было трудно: в 17 лет я попал в этот город и 2.5 года
          прожил в нем. Я плохо себя чувствовал от того, что иду по улице, а
          следующая улица не идет так же, как эта. От того, что улица вихляет, я
          чувствовал дискомфорт. Думаешь, что все это умозрительно, но,
          оказывается, как-то действует на сознание.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—L]</Link>
          </sub>
        </>
        <>
          Очень меня тяготил этот город, во многом непонятно контрастировавший с
          любимым Ленинградом, а атмосфера консерватории с постоянными
          соревнованиями и получениями призов полностью противоречила моему
          характеру. Я точно знал – это не мой мир, и не хотел становиться его
          частью. М. Л., как радар, все улавливал и постоянно спрашивал: «Ну,
          старик, что ты задумал?» Впоследствии признался: «Чувствовал всегда –
          ты воздвиг щит между нами».
        </>
        <>
          Несмотря на «щит», Мстислав Леопольдович чувствовал – я находился в
          другом измерении. Был «чужой и среди своих, и среди чужих». Он знал –
          меня можно было заманить только музыкой.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/5.jpg`}
        />
        <Spacer half size={4} />
        <>
          За два года я прошел весь классический репертуар, а кроме того, под
          влиянием его превосходного пианизма пережил сильное увлечение
          фортепиано. В особенности романтическими виртуозными пьесами с их
          техническими «наворотами».
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>катастрофа</SubTitle>
        <>
          «Шеф, а ты играл концерт Дворжака?» – «Нет». – «Вот! Я сегодня уезжаю,
          четверг, пятница, суббота... Значит так, в воскресенье я приезжаю, ты
          мне его выучи к воскресенью».
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[A—A]</Link>
          </sub>
        </>
        <>
          М. Л. дал три дня, как одержимый я навалился на бедную виолончель, и к
          исходу третьих суток одолел всю партитуру наизусть (а это практически
          симфония). Но физическое напряжение обрушилось настоящей катастрофой:
          зашел кто-то важный, и Ростропович запросил весь концерт снова –
          целиком! К финалу одна из рук совершенно онемела и просто уже висела.
          Мне диагностировали неврит, рекомендовали полнейший «отруб». Я не мог
          ею вообще пошевелить, не говоря уж об игре на виолончели. Понадобились
          месяцы всевозможных процедур, включая иглоукалывание, прежде чем руку
          спасли.
        </>
        <>
          Впоследствии понял – травма была послана свыше: отказ от виолончели
          полностью отдал меня сочинению. Я смог покинуть бесконечно томившую
          меня Москву, а виолончель без колебаний «превратил» в рояль.
        </>
        <>
          Такой исход еще больше высветил пронзительность нашей встречи.
          Конечно, тут были не просто отношения учителя и ученика. Мстислав
          Леопольдович стал частью меня, и, как показала жизнь, наши судьбы
          действительно оказались тесно переплетенными.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>второй отец</SubTitle>
          <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
          <>
            Я познакомилась с ним, когда он еще плохо представлял себе, что он
            такое. И я не понимала масштаба его дарования. Он только что оставил
            виолончель, но то, что он был учеником Ростроповича, имело огромное
            значение и сформировало его мировоззрение. И вообще для него
            Мстислав Леопольдович – это второй отец. Он во многом ему подражал.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>«сонаты кшенека»</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            Причина была не только в том, что он переиграл руку, это скорее
            следствие. Уже обучаясь в Московской консерватории, Кнайфель
            начинает пробовать себя именно как композитор. Самые ранние
            композиторские опыты – полушутливые. Когда они учились с Банщиковым
            в школе-десятилетке, были приняты шефские концерты в совхозах, на
            заводах, и они играли сонаты Кшенека. Они договаривались, в каком
            месте сходятся, а дальше въяривали так, что струны звенели. Это была
            чистой воды импровизация, и можно было делать все, что угодно –
            никто, естественно, никаких сонат Кшенека не знал.
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>кнайфелевский стиль</SubTitle>
          <>
            Но это было скорее юношеское хулиганство, а вот в Москве он начинает
            уже серьезно заниматься музыкой. Ему было 17 лет, когда он создает
            свой первый опус –<NBSP />
            <a
              href="https://youtu.be/fegvuurxnFI"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              «Соната о сказке»
            </a>
            . 12 минут красивой настоящей музыки.
          </>
          <>
            Он решил принести на экзамен по композиции целую стопочку своих
            сочинений: там как раз и «Соната о сказке», и сочинение, которое
            называлось «Заседание струнных у тромбона», – гротесковые вещи, в
            которых уже очень явно был слышен кнайфелевский стиль. И здесь как
            раз он получил вердикт.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[A—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/6.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>нет предмета для оценки</SubTitle>
        <Text>александр кнайфель:</Text>
        <>Я уже писал [музыку], но никто этого не признавал абсолютно.</>
        <>
          В то время композиции я не учился, но заходил иногда к [Сергею
          Владимировичу] Баласаняну – деликатнейшему, интеллигентнейшему. Потом
          решился представить [ему] первые сочинения. И тут случилось нечто.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <>
          «Милый Шура, мы все-таки кафедра, мы оцениваем музыку. Музыка может
          быть плохая или хорошая, не очень хорошая или совсем плохая. Но в
          вашем случае нет предмета оценки».
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[A—A]</Link>
          </sub>
        </>
        <>
          Я, конечно, был восхищен (все-таки получить такое, почти
          неправдоподобное признание, и уже в 18 лет!), хотя мои друзья,
          особенно Сонечка Губайдулина, этого восхищения не разделяли. А кроме
          того – появился, наконец, шанс вернуться домой!
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>ленинградская консерватория, класс композиции</SubTitle>
        <>
          После того, как мне сказали в Москве, что нет предмета оценки, мои
          родители страшно переживали. Они, конечно, рассчитывали, что я буду
          лауреат – все же тринадцать лет учился на виолончели, – и иного для
          меня не хотели. А тут я впервые в истории ухожу из класса
          Ростроповича!
        </>
        <>
          Был у них друг большой, один из ведущих профессоров ленинградской
          консерватории, Вадим Николаевич Салманов, и они говорят: «Ну сделайте
          что-нибудь, только чтобы этого не произошло». И я помню: экзамены на
          поступление в класс композиции, родители стоят в коридоре, трясутся,
          как осиновый лист, он выходит и им говорит: «Ничем помочь не могу,
          принимаем сразу же на третий курс».
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>минимум на бумажке</SubTitle>
        <>
          А дальше повезло еще больше. В консерватории я определенно не знал,
          что делать.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—L]</Link>
          </sub>
        </>
        <>
          Поэтому через полгода явился в лаборантскую своего факультета, там
          сидела такая пожилая секретарь, потомственная аристократка, и я ей
          прямым текстом говорю: «Знаете, у меня к вам немножко необычная
          просьба. Не могли бы вы мне написать на бумажке тот минимум, который я
          должен в этой консерватории делать, чтобы меня не вышибли». Она так на
          меня диковато посмотрела, но покорно написала за третий, за четвертый,
          за пятый курс – все, что нужно. Я взял этот список и в консерватории
          вообще не появлялся.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>арапов</SubTitle>
        <>
          Меня зачислили в класс Бориса Александровича Арапова – почтенный
          профессор, невероятной доброты. Он меня вообще не видел, но был
          по-детски непосредственен, и когда я приходил (на экзамен-то надо
          прийти), все сидели, а он прямо тянулся к нотам. Коллеги ему: «Борис
          Александрович, ну что вы, сядьте, все сидят. Как будто вы никогда
          этого не видели и не слышали». А он действительно первый раз слышит!
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <>
          Вот вся моя консерваторская эпопея.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—L]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>что из этого получится?</SubTitle>
          <QuoteCinemaText>татьяна мелентьева: </QuoteCinemaText>
          <>
            Помню, мы гуляли по Невскому в период ухаживаний, и я видела, что он
            растерян, не понимал еще, на что ему опираться, но в нем бродили
            возможности и потребность творить. Так что в сочинения он окунулся с
            головой, ему это нравилось – но что из этого получится? Я
            чувствовала, что у него были моменты некоторых сомнений, обычно ему
            не свойственные.
          </>
          <Spacer half size={8} />
          <SubTitle>стремление к композиции, как к открытию</SubTitle>
          <>
            В Москве у него вообще ничего не получилось, там его не приняли, не
            поняли. Там он работал в Театре теней, и играл мне оттуда номера –
            это было очень удачно. Тогда он был совсем еще молокосос, учился на
            виолончели, и написал музыку к их спектаклю – уже прорывалось
            композиторское начало, его любовь к тому, чтобы найти что-то свое,
            оригинальное.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={8} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/7.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>первые успехи</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            Первая нашумевшая вещь – опера
            <NBSP />
            <a
              href="https://youtu.be/2LG6Fv7clEk"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              «Кентервильское привидение»,
            </a>
            <NBSP /> по сюжету известного рассказа Оскара Уайльда. Произведение
            стало дипломной работой молодого композитора, в которой уже в полной
            мере проявились черты его зрелого стиля, когда за внешней историей
            скрывается духовная притча.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—C]</Link>
            </sub>
          </>
          <Spacer half size={4} />
          <>
            На премьере была Галина Ивановна Уствольская, которая пришла в
            восторг, а она очень редко оценивала музыку своих коллег. Кнайфель
            рассказывал, что она бегала за ним: «Ну надо же, ну надо же!»
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[A—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>в союз композиторов</SubTitle>
          <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
          <>
            Эта опера на старте карьеры стала его визиткой, с ней он был принят
            в Союз композиторов. Тогда это считалось местом работы: не став
            членом Союза, он считался бы тунеядцем, как Бродский.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/8.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>театр и кино</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Театр меня всегда очень сильно привлекал, особенно музыкальный. И даже
          кинематограф – в юности, лет в 14-15 я очень хотел быть
          кинорежиссером, а потом у меня было сочинение, до конца не
          оформленное, – несколько пьес для киноленты. Но музыку в кино я не
          различал.
        </>
        <Spacer half size={4} />
        <SubTitle>выбор</SubTitle>
        <>
          Когда окончил консерваторию в Ленинграде, надо же случится такому, что
          в этот момент я серьезно заболел. И заболел очень редкой болезнью
          крови, мононуклеоз, она не фатальная, но невероятно изнуряющая. А у
          меня было распределение в какое-то провинциальное училище, куда я
          должен был поехать как преподаватель музыкально-теоретических
          дисциплин по своей специальности. Но выдали медицинскую справку – с
          распределением было покончено. Счастливчик!
        </>
        <>
          А в свои 22 года – достаточно рано – я уже был женат, и у нас была
          маленькая дочка Аннушка. Нужно было обеспечивать семью, и меня
          пристроили в издательство «Композитор» редактором — тогда это было
          очень хорошее место. Я проработал честно несколько лет, но в один
          момент явственно понял: не могу больше так жить, я должен
          реализовывать Богом данное! Со стороны это могло показаться барством:
          я не хочу работать, потому что мне надо писать музыку. Но я ясно
          понимал: не пропадем! Ну что такого будет? Что, я или мои близкие
          умрут с голода? Это невозможно! Да, мы откажемся от чего-то, но чтобы
          не существовать, а жить во всей полноте.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/9.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>турнирная музыка</SubTitle>
        <>
          Я тогда немножечко уже контактировал с телевидением, сделал две{" "}
          <NBSP />
          <a
            href="https://youtu.be/NWjA--3yBlM"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            музыкальные заставки для телепередач
          </a>
          .
        </>
        <>
          Одна называлась «Турнир СК». Всего одна минута, но такая фонограмма –
          блестящая совершенно. И обе эти заставки не были приняты, но доставили
          мне много радости. Они, конечно, были слишком хороши для них.
        </>
        <Spacer half size={4} />
        <SubTitle>телеспектакль «петроградские воробьи»</SubTitle>
        <>
          В 1960-е годы это было очень распространено – на телевидении ставили
          спектакли. Их снимали, но это были не телефильмы, а телеспектакли.
          Одним из авторов там был Лев Лосев, кстати говоря, ближайший друг
          Бродского, в Америку довольно рано эмигрировал. Это его псевдоним,
          вообще он Лев Лившиц, настоящий большой поэт, и стихи в этом спектакле
          тоже совершенно изумительные.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/10.jpg`}
        />
        <Spacer half size={4} />
        <>
          Спектакль был большой, емкий, но именно в этот момент я заболел той
          самой болезнью крови. Каждый день температура 41. Я слег, но никого
          это не касалось, я всю партитуру написал в постели в бреду, возможно,
          каким-то образом это сказалось, потому что сразу же вызвало
          невероятную реакцию.
        </>
        <>
          Это врывается, как в былые времена, если вы стоите у газетного киоска,
          взяли свежий номер газеты, раскрыли – и вот вы видите: вся
          фантасмагория…
        </>
        <>
          Это настолько ярко и неожиданно возникало: «Циркач»,
          <NBSP />
          <a
            href="https://youtu.be/gTr15Z6B3HU"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Бегство воронья»
          </a>
          , «Красногвардейцы», «Шарманщик»,
          <NBSP />
          <a
            href="https://www.youtube.com/watch?v=jKDQq2KDuMI&feature=youtu.be"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Погони»
          </a>
          … Тогда я еще в кино не работал, это 1967 год, но, по сути дела
          абсолютно кинематографическая партитура, в которой представляется то,
          что происходило в Петрограде в неуловимую, непостижимую и загадочную
          эпоху, когда Россия встала на дыбы.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/11.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/12.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/13.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/14.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/15.jpg`,
            },
          ]}
        />
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>прикладная музыка для телевизионного спектакля</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            Мне кажется, что у Кнайфеля сразу же проявляется удивительный
            театральный дар, который имеет свою специфику: он слышит некоторые
            вещи, как мы бы сейчас сказали, абсолютно не конвенционно. Где-то
            переворачивает их наоборот, идет не от эмоции, как принято в
            привычном театре. Обычно, если трагедия, значит, будет звучать
            что-то мрачное, тяжелое, в миноре, а тут совершенно другие вещи
            происходят, он пользуется другой логикой. И, конечно, «Петроградские
            воробьи» получили резонанс.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[A—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          Это чисто заказная работа – музыка к телевизионному спектаклю. Но я
          органически не мог представить, что я буду это делать просто так, что
          мне это самому жизненно необходимо.
        </>
        <Spacer half size={4} />
        <SubTitle>якобсон</SubTitle>
        <>
          Я как кошка, которая гуляла сама по себе, быстро отошел от этой работы
          и переключился на другое. С великим балетмейстером Леонидом Якобсоном
          мы сделали хореографический стриптиз «Разоружение» (по карикатурам
          Битструпа. – Примеч. авт.), а потом «Кающуюся Магдалину» (балетную
          сцену по произведениям Тициана и Родена. – Примеч. авт.).
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
          <>
            От Якобсона он был в восторге, тот работал, сливая музыку с
            движением. Шурик сам попросился аккомпанировать у него на занятиях,
            на репетициях как тапер, концертмейстер.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/15a.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>умение схватывать жест</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            И тут проявляется его способность схватывать жест, что остается с
            ним до конца жизни. Жест как зарисовка, или как молчание, или как
            выражение. И Кнайфель моментально находит общий язык с хореографами,
            в частности, с Якобсоном и с<NBSP />
            <a
              href="https://youtu.be/JwncIY-Mwfo"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              Алексидзе
            </a>
            .
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—C]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/16.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>письмо ленина к съезду</SubTitle>
          <>
            1969 год, страна готовится к 100-летию Ленина, и Соломон Волков,
            известный автор, ныне живущий в Нью-Йорке, подает провокационную
            идею:
            <NBSP />
            <QuoteBlock />
            <NBSP />
            Это известное письмо, написанное 24 октября 1917 года, и Кнайфель на
            полном серьезе берется за его обработку — слово за словом оно
            полностью зафиксировано. Причем делает это в технике додекафонии.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[A—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>красота совершенная, а глаз нет</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Волков хотел сделать спектакль, я остановился только на этом письме.
          Это полностью документальный текст: «Я пишу эти строки вечером 24-го
          ... промедление в восстании смерти подобно». Полностью, весь текст, с
          подачи Волкова. Огромный хор, оркестр и такая эстетика древнегреческой
          статуи – красота совершенная, а глаз нет. Не за что полюбить.
          Называются аргументы де-юре – Ленин юрист по образованию, там все
          выстроено логически, а людей нет. Это и по сей день так.
        </>
        <>
          За эту партитуру меня даже вызывали в Смольный: «Нельзя писать на
          текст Ленина!» Причем это провокация, потому что Министерство культуры
          сначала со мной договор заключило, а по готовности вызвали. Я поперся
          в Москву, в это министерство. Но это всё дела давно минувших дней.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>во всей красе</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт, дирижер:</QuoteCinemaText>
          <>
            Хотя мы и учились в одной школе, но он был существенно старше, на
            шесть лет, и по школе я его не помню совершенно. А потом я поступил
            в консерваторию в класс к дирижеру Авениру Васильевичу Михайлову. И,
            когда я был на втором курсе, он нас познакомил с Шуриком, они уже
            были знакомы по Сортавале – подружились в Доме творчества
            композиторов. И Шурик к нему обратился: он тогда как раз закончил
            «Письмо Ленина членам ЦК», надо было это записать. Это 1968 год.
          </>
          <Spacer half size={4} />
          <>
            Сочинение было заказано Министерством культуры, запись отправили,
            там послушали и сказали, что это совсем никуда не годится, что они
            не на это рассчитывали. Рассчитывали на что-то вроде Холминова или
            Хренникова.
          </>
          <Spacer half size={4} />
          <>
            Музыка для ушей Министерства культуры была абсолютно чуждой. Там
            Александр Аронович уже во всей красе, он всегда был во всей красе.
            Его музыка просто очень разная, она совершенно не похожа ни на что
            другое.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>«эх, шурик, где твоя “жанна”?»</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            Но нужно дальнейшее движение, Кнайфель понимает, что просто быть
            театральным композитором, даже талантливым и интересным, – это не
            совсем то, что ему нужно. Ему уже заказана следующая театральная
            вещь – балет о Жанне д’Арк. Он начинает писать, но спотыкается –
            ничего не получается. Возникает большая пауза в несколько лет.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—C]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/17.jpg`}
        />
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          Калерия Федичева [исполнительница балетов «Кающаяся Магдалина» 1967 и
          «Монодия» 1968 на музыку Кнайфеля] очень просила меня сделать балет по
          Жанне д’Арк. И это было начало большого сочинения
          <NBSP />
          <a
            href="https://youtu.be/SnY2YLhJ6bs"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Жанна»
          </a>
          , которое оказалось судьбоносным, благодаря нему я в каком-то смысле
          родился.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <>
          Я начал в 1970, сделал первую часть (164 такта. – Примеч. авт.),
          которую многие знали. А потом почему-то остановился и не мог идти
          дальше. Был целый период, когда я внутренне затаился, замолчал. И
          продолжалось это лет пять, пока не получил письмо от моего друга
          Татьяны Александровны Ворониной, ездившей в 1975 году на похороны
          Дмитрия Дмитриевича Шостаковича. Она подробно все описала, понимая,
          что эта личность значила для меня. И это большое письмо вдруг
          кончалось маленькой припиской: «Эх, Шурик, Шурик… Где твоя «Жанна»?»
          Меня просто обожгло. Сочинение прорвалось, я вдруг понял, что пять лет
          молчал не зря. Начались интенсивные годы работы, и летом 1978 года все
          было завершено.
        </>
        <>
          Когда она была сделана, я никак не мог охватить образовавшуюся
          вселенную, я пытался все время ее обжить, хоть она уже существовала.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>число как проверка</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            После большого перерыва он снова вернулся к этому произведению, но
            уже с позиции числа.
          </>
          <Spacer half size={4} />
          <>
            Число как проверка, как некая объективная данность, как некий
            фундамент, на который можно опереться. Он сознательно не опирается
            на гармонию, классико-романтические тональности, театральные вещи,
            которые хорошо чувствует, и до конца жизни с ними продолжает
            взаимодействовать. Но он понимает, что число должно быть в основе
            всего, все проверяется через него. И «Жанна» — это уже числовая
            матрица, которая потом станет обязательной для всех его опусов.
            Перед тем, как приступить к сочинениям, он берет миллиметровую
            бумагу и расставляет, что будет в основе: числовые ряды,
            последовательности, как они будут сочетаться. А чуть позже к ним он
            добавит еще и слово.
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>собственный творческий метод</SubTitle>
          <>
            Произведение рассчитано на оркестр из 56 солистов и предполагает
            пространственное размещение музыкантов в зале. Именно с «Жанны» он
            начал оформлять собственный творческий метод, назвав ее одним из
            краеугольных своих сочинений. После нее он перестает писать
            традиционную музыку и выбирает свою абсолютно неповторимую стезю,
            которой остается верен до конца дней.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—C]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>новый стиль</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          В «Жанне» каждый звук словно бы оплачен моей кровью… Думал, что пишу
          последнюю вещь, оказалось — первую! Первую в ряду произведений нового
          стиля. После этого сочинения я стал совершенно другим человеком, все
          клеточки обновились.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—L]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/18.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <SubTitle>понизовский</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Потом, в 1974-м, Шурик мне предложил вещь, от которой я отказался,
            испугавшись. Это произведение
            <NBSP />
            <a
              href="https://youtu.be/NxW0YHkohIo?si=xNuvdhCt2ebSXXp3"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              Status nascendi
            </a>
            , которое исполнялось в Малом зале филармонии: хор располагался по
            всей площади зала, на сцене ходили люди в черном, и дирижер должен
            был всем этим управлять. Но я испугался не этого, испугался
            партитуры. Она была совершенно необычная, круглая, ее надо было
            крутить, в общем, я понял, что мне это пока не по зубам
          </>
          <Spacer half size={4} />
          <Carousel
            autoHeight
            slides={[
              { url: `${PUBLIC_URL}/assets/images/knaifel/recognition/22.jpg` },
              { url: `${PUBLIC_URL}/assets/images/knaifel/recognition/23.jpg` },
            ]}
          />
          <Spacer half size={4} />
          <>
            Этим занимался Боря Понизовский, с которым я тогда еще не был
            знаком, он выступал как режиссер.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—D]</Link>
            </sub>
          </>
          <Spacer half size={4} />
          <Image
            alt="Александр Кнайфель"
            src={`${PUBLIC_URL}/assets/images/knaifel/recognition/19.jpg`}
          />
          <Spacer half size={4} />
          <>
            В спектакле участвовало двадцать пять хористов, они делились на три
            группы: одна находилась на сцене, другая рассаживалась среди
            зрителей, а третья располагалась по периметру зала. У каждого
            исполнителя была своя партия, соответствующая его условному номеру,
            своя тональность, ритм, время звучания. Солисты учились
            синхронизировать свои передвижения в пространстве с голосом. ...
            Звук то нарастал, то рассеивался в пространстве. Его источник
            невозможно было сразу определить. Таким образом, акустическое
            пространство отделялось от визуального мира, заставляя работать
            зрительское воображение. Голос пересоздавал пространство заново,
            провоцируя слушателей каждый раз по-новому воспринимать его.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[E—G]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/20.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/21.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/24.jpg`,
            },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>хренниковский съезд</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          1979 год, ноябрь, Кремлевский дворец, VI съезде Союза композиторов
          СССР. Партитуры и книги, которых вы не найдете нигде, за копейки там
          стоят, столы ломятся икрой и коньяками.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/25.jpg`}
        />
        <Spacer half size={4} />
        <>
          Все улыбаются, хлопают тебя по плечу. Рассаживаются. Первый и самый
          главный доклад у самого главного. Заканчивается этот доклад,
          объявляется перерыв, я выхожу, очень много знакомых из разных городов
          и республик, и вот все те, кто только что хлопал тебя по плечу, с кем
          ты лобызался, смотрят на тебя и не узнают в упор. Без исключений. Это
          надо пропустить через свою шкуру. Это было первый и последний раз.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema dots={false}>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            В чем был пафос доклада первого секретаря Тихона Хренникова? Семь
            композиторов подверглись критике за «авангардизм», отсутствие
            содержательности и злоупотребление внешними эффектами. Хренникова
            особенно задел тот факт, что на Западе вместо того, чтобы брать
            хороших советских авторов, выбирают всяких формалистов: произведения
            перечисленных им авторов уже исполнялись на престижных западных
            фестивалях (в Кельне и Венеции), в отличие от музыки официально
            признанных и обласканных советских мэтров. Такая банальная зависть.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—С]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>хренниковская семерка</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Перекрыли кислород весьма основательно. Денисов, Губайдулина, Артёмов,
          Фирсова, Смирнов, Суслин.
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/27.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/28.jpg`,
            },
            {
              url: `${PUBLIC_URL}/assets/images/knaifel/recognition/29.jpg`,
            },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>партитура-мишень</SubTitle>
        <>
          <a
            href="https://youtu.be/Ksn4iKp21GI?si=QXz_f7jL7m5dEGN7"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «А prima vista»
          </a>
          <NBSP /> послужила основой публичного скандала и невероятного шума на
          Хренниковском съезде. Премьера состоялась в Кельне, я не знаю, кто там
          был: они попросили – я послал, и это было исполнено. Там партитура в
          виде круга, некоторые говорят, что это похоже на мишень, но это не
          умышленно, просто такое совпадение.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/recognition/30.jpg`}
        />
        <Spacer half size={4} />
        <>
          Изначально это красиво выглядит: круг в четырех положениях, музыканты
          переходят, меняются местами. Модель исполнительского драйва. Для
          ударных то, что надо. Там есть зоны, где написано, как инструмент
          должен звучать. Сыграть буквально невозможно. Это сугубо
          импровизационная вещь: все, что звучит, – это не мое сочинение, это
          сочинение исполнителей.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>мастер компромисса</SubTitle>
        <>
          По мне советские катки почти не проехали, во многом потому, что я был
          не в Москве, а в Петербурге. А там Союзом композиторов руководил
          замечательный Андрей Петров, настоящий петербургский интеллигент, при
          этом редкий мастер компромисса. Он просто сглаживал здесь многое из
          того, что приходилось хлебать московским композиторам, которые
          жаловались, что не могут работать.
        </>
        <Spacer half size={4} />
        <SubTitle>родителей не выбирают</SubTitle>
        <>
          Сонечка Губайдулина, Арво Пярт и некоторые другие из моих друзей
          уехали за рубеж… У меня никогда этой внутренней озлобленности не было.
          Родителей не выбирают. Мне всегда казалось, что к подлинным проблемам
          это не относится, – в конце концов, рождались же шедевры даже в
          лагерях.
        </>
        <Spacer half size={4} />
        <SubTitle>делание</SubTitle>
        <>
          Есть такое замечательное слово — «делание». Когда есть делание — нет
          других вопросов. Делание — это единственно достойное существование. А
          еще есть такое ключевое в русском языке слово (я думаю, что оно
          непереводимо по своей сути) — «празднование». То есть делание в
          радости и лучистости, в сиянии, то есть делание во славу Господа.Нам с
          государством просто не было никакого дела друг до друга. Я всю жизнь
          был в этой счастливой ситуации.
        </>
        <>
          Есть физическая возможность работать – это самое главное. У меня
          физическая возможность была. Кроме того, в самое трудное время меня
          подхватил кинематограф.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      <Spacer half size={10} />
    </SidesKnaifel>

    <Spacer size={80} />

    <Footer />
  </TypographyWrapper>
);

export default Recognition;
